module.exports = __webpack_public_path__ + "static/media/curatorial-6.995cec17.jpg";